import React, { useMemo, useState } from 'react';
import { SearchOutlined } from '@mui/icons-material';
import { Avatar } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import Theme from 'App.theme';
import InputField from 'components/InputField';
import SettingsModal from 'components/SettingsModal/SettingsModal';
import TenantDropDown from 'components/TenantDropDown/TenantDropDown';
import { useLanguage, useSearch, useTenant } from 'context/AppContext';
import { Role, userRolesIndex } from 'store/user/auth0.helpers';
import { useUser } from 'store/user/useUser';
import { isInMaxKelsenOrg, isSatoVideoReviewer } from 'utils/helpers/permissions.helpers';
import { AvatarButton, HeaderContainer } from './Header.styles';

const Header: React.FC = () => {
  const [locale] = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedTenant, dispatchTenant] = useTenant();
  const user = useUser();
  const [search, dispatchSearch] = useSearch();

  const [openSettingsModal, setOpenSettingsModal] = useState(false);

  const initialsAvatar = user.isAuthenticated ? user.email?.slice(0, 2).toUpperCase() : null;
  const imageAvatar = user.isAuthenticated ? user.picture : null;

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
    dispatchSearch(e.target.value);
    location.pathname !== '/search' && navigate('/search');
  };
  const disableInput = useMemo(() => isSatoVideoReviewer(user), [user]);

  const isMkSuperUser = useMemo(
    () => user.isAuthenticated && user[userRolesIndex].includes(Role.MkSystemAdmin) && isInMaxKelsenOrg(user),
    [user],
  );

  return (
    <HeaderContainer>
      <div style={{ width: '98%' }}>
        {isMkSuperUser && <TenantDropDown selectedTenant={selectedTenant} changeTenant={dispatchTenant} />}
        <InputField
          style={{ marginTop: '5px', marginBottom: '5px', width: isMkSuperUser ? '88%' : '100%' }}
          variant="outlined"
          placeholder={locale.Header.searchPlaceholder}
          InputProps={{ startAdornment: <SearchOutlined sx={{ color: Theme.greys.GREY2, mr: '1rem' }} /> }}
          value={search}
          onChange={handleSearch}
          disabled={disableInput}
          autoFocus={location.pathname === '/search'}
        />
      </div>
      <AvatarButton style={{ marginRight: '2px' }} onClick={() => setOpenSettingsModal(true)}>
        {user.isAuthenticated && imageAvatar ? <Avatar src={imageAvatar} /> : <Avatar>{initialsAvatar}</Avatar>}
      </AvatarButton>
      <SettingsModal open={openSettingsModal} close={() => setOpenSettingsModal(false)} />
    </HeaderContainer>
  );
};

export default Header;
